import { HttpHeaders } from "@angular/common/http";

export const httpOptionsV1 = {
    headers: new HttpHeaders({
      'version': 'v1'
    })
  };
export const httpOptionsV2 = {
    headers: new HttpHeaders({
      'version': 'v2'
    })
  };
export const httpOptionsV3 = {
    headers: new HttpHeaders({
      'version': 'v3'
    })
  };
export const httpOptionsV4 = {
    headers: new HttpHeaders({
      'version': 'v4'
    })
  };
export const httpOptionsV5 = {
    headers: new HttpHeaders({
      'version': 'v5'
    })
  };

  export const httpOptionsV6 = {
    headers: new HttpHeaders({
      'version': 'v6'
    })
  };